import { Text } from '@mantine/core';
import { modals } from '@mantine/modals';
import { useTranslation } from 'react-i18next';

import { trackBudgetLineDeleted } from 'src/Services/Mixpanel/events';
import { formatEuros } from 'src/Utils/budgetWizardMath';

export type BudgetWizardStep = 'fixed_costs' | 'projects' | 'incomes';

// One place to open the "Retirer cette ligne ?" confirmation from every wizard step.
const useConfirmRemoveWizardLine = (step: BudgetWizardStep) => {
  const { t } = useTranslation();

  return (label: string, amount: number, remove: () => void) => {
    modals.openConfirmModal({
      title: t('budgetV2.lineActions.confirmTitle', 'Retirer cette ligne ?'),
      children: (
        <Text size="sm">
          {t('budgetV2.lineActions.confirmMessage', {
            defaultValue: '{{label}} — {{amount}} ne comptera plus dans votre budget.',
            label,
            amount: formatEuros(amount),
          })}
        </Text>
      ),
      labels: {
        confirm: t('budgetV2.lineActions.confirmRemove', 'Retirer'),
        cancel: t('budgetV2.lineActions.keep', 'Garder'),
      },
      confirmProps: { color: 'red' },
      onConfirm: () => {
        trackBudgetLineDeleted({ step });
        remove();
      },
    });
  };
};

export default useConfirmRemoveWizardLine;
